import React from 'react';
import { useRouterI18nHooks } from 'src/hooks/useRouterChange';
import { get } from 'lodash';
import { Spin } from 'antd';

const I18nWrapper = (props: any) => {
  const { children, _props } = props;
  const path = get(_props, 'match.path');
  const url = get(_props, 'match.url');
  const { loading } = useRouterI18nHooks({ path, url });

  return (
    <React.Fragment>
      {loading && (
        <Spin
          style={{
            width: 'calc(100% - 240px)',
            height: 'calc(100% - 168px)',
            position: 'fixed',
            zIndex: 9,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.05)',
          }}
          spinning={loading}></Spin>
      )}

      {children}

      {/* <Spin
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: 999999,
        }}
        spinning={
          true //loading
        }></Spin> */}
    </React.Fragment>
  );
};
export default I18nWrapper;
